import React, { useEffect } from 'react';
import { Path } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';

import application from 'application';

import internalEventCodes from 'event-system/codes/internal';

import HelptapEditor from '../../helpers';

function HTMLImporter(props) {

  const element = props.element;

  const editor = useSlateStatic();

  const elementPath = ReactEditor.findPath(editor, props.element);

  useEffect(function onLoad() {

    parseAndRenderHTML();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function parseAndRenderHTML() {

    let nodes = [];

    try {

      nodes = await HelptapEditor.htmlImporter.fromFile(element.file);

      if (nodes.length === 0) {
        application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
          message: 'Unable to import blocks from HTML',
          seconds: 5,
          type: 'error'
        });
      }

    } catch (exception) {

      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message: 'Unable to import HTML. Contact administrator!',
        seconds: 5,
        type: 'error'
      });

    }

    HelptapEditor.insertNodes(editor, nodes);

    HelptapEditor.deleteNodeByPath(editor, elementPath);

  }

  function renderMain() {

    return <div className="html-importer-main">
      {props.children}
      <ht-spinner></ht-spinner>
    </div>;

  }

  return renderMain();

}

export default HTMLImporter;